<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">{{ title }}</h1>
    <el-row :gutter="10" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="timestamp"
          :picker-options="datePickerOptions"
          @change="handleDateRangeChange"
          style="width: 100%"
        ></el-date-picker>
      </el-col>
      <el-col :span="5">
        <el-input v-model="queryData.cid" placeholder="通话编号" clearable />
      </el-col>
      <el-col :span="3">
        <el-input v-model="queryData.toRid" placeholder="主播ID" clearable />
      </el-col>
      <el-col :span="3">
        <el-input v-model="queryData.fromRid" placeholder="用户ID" clearable />
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.toAppraiseLevel"
          placeholder="主播等级"
          clearable
          filterable
        >
          <el-option
            v-for="item in toAppraiseLevelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.fromType"
          placeholder="通话类型"
          clearable
          filterable
        >
          <el-option
            v-for="item in fromTypeOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="3">
        <el-select v-model="duration" placeholder="通话时长" clearable filterable>
          <el-option
            v-for="item in durationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <!-- channelsList用户渠道、主播渠道 -->
      <el-col :span="3">
        <el-select
          v-model="queryData.fromChannel"
          placeholder="用户渠道"
          clearable
          filterable
        >
          <el-option
            v-for="item in channelsList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.toChannel"
          placeholder="主播渠道"
          clearable
          filterable
        >
          <el-option
            v-for="item in channelsList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.fromCountryCode"
          placeholder="用户国家"
          clearable
          filterable
        >
          <el-option
            v-for="item in countryList"
            :key="item.countryCode"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.fromLang"
          placeholder="用户语言"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in langList"
            :key="index"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.toCountryCode"
          placeholder="主播国家"
          clearable
          filterable
        >
          <el-option
            v-for="item in countryList"
            :key="item.countryCode"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.toLang"
          placeholder="主播语言"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in langList"
            :key="index"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-button type="warning" @click="getList" :loading="login1"> 查询 </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="3">
        <el-select
          v-model="queryData.evaluateType"
          placeholder="评价类型"
          clearable
          filterable
          @change="handleEvaluateTypeChange"
        >
          <el-option
            v-for="item in evaluateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="queryData.evaHandleStatus"
          placeholder="评价处理状态"
          clearable
          filterable
        >
          <el-option
            v-for="item in evaHandleStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table :data="list" v-loading="login1" border :span-method="objectSpanMethod">
        <el-table-column prop="cid" label="视频编号id" align="center" />
        <!-- 通话类型 fromType，根据fromTypeOptions渲染 -->
        <el-table-column prop="fromType" label="通话类型" align="center">
          <template slot-scope="scope">
            <span v-for="item in fromTypeOptions" :key="item.value">
              <span v-if="item.value == scope.row.fromType">{{ item.name }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="身份" align="center" />
        <el-table-column prop="rid" label="用户ID" align="center" />
        <el-table-column prop="name" label="用户名称" align="center" />
        <el-table-column prop="channel" label="用户渠道" align="center" />
        <el-table-column prop="appraiseLevel" label="主播等级" align="center">
          <template slot-scope="scope">
            <span v-for="item in toAppraiseLevelOptions" :key="item.value">
              <span v-if="item.value == scope.row.appraiseLevel">{{ item.label }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="通话时长" align="center" />
        <el-table-column prop="countryCode" label="国家" align="center" />
        <el-table-column prop="mute" label="是否静音" align="center">
          <template slot-scope="scope">
            <!-- el-tag展示 -->
            <el-tag v-if="scope.row.mute == 1" type="success">静音</el-tag>
            <el-tag v-else type="danger">非静音</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="user_lang" label="语言" align="center" />
        <el-table-column prop="callTime" label="" align="center">
          <template slot-scope="scope">
            <span>{{ format_(scope.row.callTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ctime" label="创建时间" align="center">
          <template slot-scope="scope">
            <span>{{ format_(scope.row.ctime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mtime" label="修改时间" align="center">
          <template slot-scope="scope">
            <span>{{ format_(scope.row.mtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center" />
        <el-table-column prop="userRobot" label="是否机器人" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.userRobot == 1" type="warning">普通机器人</el-tag>
            <el-tag v-else-if="scope.row.userRobot == 2" type="danger">私call机器人</el-tag>
            <el-tag v-else type="info">否</el-tag>
          </template>
        </el-table-column>
        <!-- endReason,根据对比reasonList的value来渲染 -->
        <el-table-column prop="endReason" label="" align="center">
          <template slot-scope="scope">
            <span> {{ formatReasonCode(scope.row) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateType" label="评价类型" align="center">
          <template slot-scope="scope">
            <span v-for="item in evaluateTypeOptions" :key="item.value">
              <span v-if="item.value == scope.row.evaluateType">{{ item.label }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="evaHandleStatus" label="评价处理状态" align="center">
          <template slot-scope="scope">
            <span v-for="item in evaHandleStatusOptions" :key="item.value">
              <span v-if="item.value == scope.row.evaHandleStatus">{{ item.label }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateReason" label="评价原因" align="center" />
        <!-- 图片 -->
        <el-table-column prop="ImgList" label="图片" align="center" width="500">
          <template slot-scope="scope">
            <div class="imgList">
              <el-image
                v-for="(item, index) in scope.row.ImgList"
                :key="index"
                :src="item"
                :preview-src-list="scope.row.ImgList"
                style="flex: 0 0 auto; width: 100px; height: 100px; margin-right: 10px"
              />
            </div>
          </template>
        </el-table-column>

        <!-- 实时视频 -->
        <!-- <el-table-column label="操作" align="center" fixed="right" width="140">
          <template slot-scope="scope">
            <div class="btns">
              
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="300">
          <template slot-scope="scope">
            <div class="btns">
              <el-button
                type="success"
                size="mini"
                @click="openNewLink(scope.row.videoUrl)"
              >
                查看视频
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="playVideo(scope.row.videoRealUrl)"
              >
                查看实时视频
              </el-button>
              <el-button type="primary" size="mini" @click="copy(scope.row.videoRealUrl)">
                复制实时视频链接
              </el-button>
              <el-button
                v-if="scope.row.gender === '用户'"
                type="warning"
                size="mini"
                @click="updateUserRobot(scope.row, 1)"
              >
                设为普通机器人
              </el-button>
              <el-button
                v-if="scope.row.gender === '用户'"
                type="danger"
                size="mini"
                @click="updateUserRobot(scope.row, 2)"
              >
                设为私call机器人
              </el-button>
              <el-button
                v-if="scope.row.gender === '用户' && scope.row.userRobot != 0"
                type="info"
                size="mini"
                @click="updateUserRobot(scope.row, 0)"
              >
                设为非机器人
              </el-button>
              <el-button
                type="warning"
                size="mini"
                v-if="scope.row.gender === '用户'"
                @click="openEvaHandleDialog(scope.row)"
              >
                评价处理
              </el-button>
              <el-button
                type="success"
                size="mini"
                v-if="scope.row.gender === '用户'"
                @click="openCompensateDialog(scope.row)"
              >
                金币补偿
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageInfo.page"
        :page-size="30"
        layout="total, prev, pager, next,jumper"
        :total="pageInfo.total"
      >
      </el-pagination>
    </el-row>
    <div v-show="vid" class="po">
      <i @click="look_()" class="el-icon-circle-close pos" style="z-index: 9999"></i>
      <video
        id="video"
        preload="auto"
        size="medium"
        type="application/x-mpegURL"
        src=""
        controls
        class="video-js vjs-default-skin"
        style="width: 480px; height: 740px; object-fit: container"
      ></video>
    </div>
    <!-- 评价处理对话框 -->
    <el-dialog
      title="评价处理"
      :visible.sync="evaHandleDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :model="evaHandleForm" label-width="100px">
        <el-form-item label="处理状态">
          <el-select
            v-model="evaHandleForm.evaHandleStatus"
            placeholder="请选择处理状态"
            style="width: 100%"
          >
            <el-option
              v-for="item in evaHandleStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="evaHandleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEvaHandle">确定</el-button>
      </div>
    </el-dialog>
    <!-- 金币补偿对话框 -->
    <el-dialog
      title="金币补偿"
      :visible.sync="compensateDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :model="compensateForm" label-width="100px">
        <el-form-item label="补偿金额">
          <el-input
            v-model.number="compensateForm.compensateGold"
            type="number"
            placeholder="请输入补偿金额"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="compensateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCompensate">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { getConstList } from "@/api/constRequest";
import videojs from "video.js";
import "videojs-contrib-hls";
import useClipboard from "vue-clipboard3";
const { toClipboard } = useClipboard();

export default {
  props: {
    defaultUserRobot: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: '视频巡查'
    }
  },
  data() {
    // 初始化默认最近7天的时间范围（UTC时间）
    // 使用本地时间的年月日，然后转换为UTC 0点
    const getUTCMidnightTimestamp = (date) => {
      const utcDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0, 0, 0, 0
      ));
      return Math.floor(utcDate.getTime() / 1000);
    };
    
    const now = new Date();
    const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    // 结束日期应该是今天的UTC 23:59:59
    const defaultStartTime = getUTCMidnightTimestamp(sevenDaysAgo);
    const todayUTC = new Date(Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23, 59, 59, 0
    ));
    const defaultEndTime = Math.floor(todayUTC.getTime() / 1000);
    
    // 用于日期选择器显示的毫秒时间戳（只包含日期部分，使用本地时间）
    const getDateOnlyTimestamp = (date) => {
      // 返回本地时间的0点时间戳，用于日期选择器显示
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      return localDate.getTime();
    };
    
    return {
      vid: false,
      duration: "",
      dialogVisible: false,
      dateRange: [getDateOnlyTimestamp(sevenDaysAgo), getDateOnlyTimestamp(now)], // 用于日期选择器显示
      queryData: {
        // 通话编号
        cid: "",
        // 主播ID
        toRid: "",
        // 用户ID
        fromRid: "",
        // 通话类型
        fromType: "",
        fromChannel: "",
        toChannel: "",
        // 通话时长最小值
        startDuration: "",
        // 通话时长最大值
        endDuration: "",
        // 主播等级
        toAppraiseLevel: "",
        // 时间范围（秒级时间戳，UTC）
        startTime: defaultStartTime,
        endTime: defaultEndTime,
        // 用户国家
        fromCountryCode: "",
        // 用户语言
        fromLang: "",
        // 主播国家
        toCountryCode: "",
        // 主播语言
        toLang: "",
        // 评价类型
        evaluateType: "",
        // 评价处理状态
        evaHandleStatus: "",
        // 用户机器人类型（用于AI电话页面）
        userRobot: null,
      },
      fromTypeOptions: [],
      evaluateTypeOptions: [
        {
          value: 0,
          label: "无评价",
        },
        {
          value: 3,
          label: "好评",
        },
        {
          value: 4,
          label: "差评",
        },
      ],
      evaHandleStatusOptions: [
        {
          value: 0,
          label: "未处理",
        },
        {
          value: 1,
          label: "已处理",
        },
      ],
      toAppraiseLevelOptions: [
        {
          value: "0",
          label: "L0",
        },
        {
          value: "1",
          label: "L1",
        },
        {
          value: "2",
          label: "L2",
        },
        {
          value: "3",
          label: "L3",
        },
      ],
      durationOptions: [
        {
          value: "0-10",
          label: "0-10s",
        },
        {
          value: "11-30",
          label: "11-30s",
        },
        {
          value: "31-60",
          label: "31-60s",
        },
        {
          value: "60",
          label: "60s+",
        },
      ],
      list: [],
      pageInfo: {
        page: 1,
        total: 0,
      },
      // 加载
      login1: false,
      channelsList: [],
      reasonList: [],
      // 国家列表
      countryList: [],
      // 语言列表
      langList: [],
      // 评价处理对话框
      evaHandleDialogVisible: false,
      evaHandleForm: {
        id: null,
        evaHandleStatus: null,
      },
      currentEvaHandleRow: null,
      // 金币补偿对话框
      compensateDialogVisible: false,
      compensateForm: {
        id: null,
        compensateGold: null,
      },
      currentCompensateRow: null,
    };
  },
  computed: {
    // 日期选择器配置
    datePickerOptions() {
      return {
        disabledDate: (time) => {
          // 如果有评价类型，限制不能跨月份
          if (this.queryData.evaluateType !== "" && this.queryData.evaluateType !== null && this.queryData.evaluateType !== undefined) {
            // 如果已经选择了开始日期，限制结束日期必须在同一个月
            if (this.dateRange && this.dateRange.length > 0 && this.dateRange[0]) {
              const startDate = new Date(this.dateRange[0]);
              const startYear = startDate.getFullYear();
              const startMonth = startDate.getMonth();
              const currentDate = new Date(time);
              const currentYear = currentDate.getFullYear();
              const currentMonth = currentDate.getMonth();
              
              // 如果当前日期和开始日期不在同一个月，则禁用
              if (currentYear !== startYear || currentMonth !== startMonth) {
                return true;
              }
            }
          }
          return false;
        },
      };
    },
  },
  created() {
    // 如果传入了 defaultUserRobot，设置到 queryData 中
    if (this.defaultUserRobot !== null && this.defaultUserRobot !== undefined) {
      this.queryData.userRobot = this.defaultUserRobot;
    }
    this.getFromType();
    this.getChannel();
    this.getCountryCode();
    this.getLang();
    this.getList();
    console.log(this.channels);
  },
  watch: {
    duration(val) {
      // 修改duration的时候，赋值、或者清空startDuration和endDuration
      if (val == "") {
        this.queryData.startDuration = "";
        this.queryData.endDuration = "";
      } else {
        if (val == "60") {
          this.queryData.startDuration = "60";
          this.queryData.endDuration = "86400";
          return;
        }
        this.queryData.startDuration = val.split("-")[0];
        this.queryData.endDuration = val.split("-")[1];
      }
    },
  },
  methods: {
    // 处理评价类型变化
    handleEvaluateTypeChange(val) {
      // 如果选择了评价类型，检查当前日期范围是否跨月
      if (val !== "" && val !== null && val !== undefined) {
        if (this.dateRange && this.dateRange.length === 2) {
          const startDate = new Date(this.dateRange[0]);
          const endDate = new Date(this.dateRange[1]);
          const startYear = startDate.getFullYear();
          const startMonth = startDate.getMonth();
          const endYear = endDate.getFullYear();
          const endMonth = endDate.getMonth();
          
          // 如果跨月了，重置为开始日期所在月份的最后一天
          if (startYear !== endYear || startMonth !== endMonth) {
            const lastDay = new Date(startYear, startMonth + 1, 0);
            const getDateOnlyTimestamp = (date) => {
              const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
              return localDate.getTime();
            };
            this.dateRange = [this.dateRange[0], getDateOnlyTimestamp(lastDay)];
            this.$message.warning("选择评价类型时，时间范围不能跨月份，已自动调整为同月范围");
            // 重新处理日期范围
            this.handleDateRangeChange(this.dateRange);
          }
        }
      }
    },
    // 处理日期范围变化
    handleDateRangeChange(val) {
      // 如果有评价类型，检查是否跨月
      if (this.queryData.evaluateType !== "" && this.queryData.evaluateType !== null && this.queryData.evaluateType !== undefined) {
        if (val && val.length === 2) {
          const startDate = new Date(val[0]);
          const endDate = new Date(val[1]);
          const startYear = startDate.getFullYear();
          const startMonth = startDate.getMonth();
          const endYear = endDate.getFullYear();
          const endMonth = endDate.getMonth();
          
          // 如果跨月了，提示并重置
          if (startYear !== endYear || startMonth !== endMonth) {
            this.$message.warning("选择评价类型时，时间范围不能跨月份");
            // 重置为开始日期所在月份的最后一天
            const lastDay = new Date(startYear, startMonth + 1, 0);
            const getDateOnlyTimestamp = (date) => {
              const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
              return localDate.getTime();
            };
            val = [val[0], getDateOnlyTimestamp(lastDay)];
            this.dateRange = val;
          }
        }
      }
      
      if (val && val.length === 2) {
        // 将选择的日期转换为UTC 0点的秒级时间戳
        // 注意：el-date-picker 返回的是本地时间的0点时间戳
        // 我们需要从本地时间中提取年月日，然后转换为UTC 0点
        const getUTCMidnightTimestamp = (timestamp) => {
          const date = new Date(timestamp);
          // 使用本地时间的年月日（因为用户选择的是本地日期）
          const utcDate = new Date(Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            0, 0, 0, 0
          ));
          return Math.floor(utcDate.getTime() / 1000);
        };
        
        // 开始日期：选择日期的UTC 0点
        this.queryData.startTime = getUTCMidnightTimestamp(val[0]);
        
        // 结束日期：选择日期的UTC 23:59:59（比如选择12/31，实际是12/31的23:59:59）
        const endDate = new Date(val[1]);
        // 基于本地日期转换为UTC，设置为当天的23:59:59
        const endDayUTC = new Date(Date.UTC(
          endDate.getFullYear(),
          endDate.getMonth(),
          endDate.getDate(),
          23, 59, 59, 0
        ));
        this.queryData.endTime = Math.floor(endDayUTC.getTime() / 1000);
      } else {
        // 清空时恢复默认值（最近7天）
        // 使用本地时间的年月日，然后转换为UTC 0点
        const getUTCMidnightTimestamp = (date) => {
          const utcDate = new Date(Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            0, 0, 0, 0
          ));
          return Math.floor(utcDate.getTime() / 1000);
        };
        
        const getDateOnlyTimestamp = (date) => {
          // 返回本地时间的0点时间戳，用于日期选择器显示
          const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
          return localDate.getTime();
        };
        
        const now = new Date();
        const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        
        this.queryData.startTime = getUTCMidnightTimestamp(sevenDaysAgo);
        // 结束日期：今天的UTC 23:59:59
        const todayUTC = new Date(Date.UTC(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23, 59, 59, 0
        ));
        this.queryData.endTime = Math.floor(todayUTC.getTime() / 1000);
        this.dateRange = [getDateOnlyTimestamp(sevenDaysAgo), getDateOnlyTimestamp(now)];
      }
    },
    formatReasonCode(row) {
      // 根据reasonList的value来渲染，没找到返回value本身
      for (let i = 0; i < this.reasonList.length; i++) {
        if (this.reasonList[i].value == row.endReason) {
          return this.reasonList[i].name;
        }
      }
      return row.endReason;
    },
    async openNewLink(value) {
      window.open(value);
    },
    async copy(value) {
      try {
        await toClipboard(value);
        this.$message.success("Copied successfully");
      } catch (e) {
        console.error(e);
      }
    },
    async getFromType() {
      const res = await getConstList("fromType");
      if (res.code != 0) return this.$message(res.msg);
      this.fromTypeOptions = res.data;

      const reasonTypeRes = await getConstList("refuseReason");
      if (reasonTypeRes.code != 0) return this.$message(reasonTypeRes.msg);
      this.reasonList = reasonTypeRes.data;
      console.log(this.reasonList);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getList();
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelsList = [{label: 'all', value: 'all'}, ...res.data]
      }
    },
    //获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList || []
      }
    },
    //获取语言
    async getLang() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.langList,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.langList = res.data || []
      }
    },
    // 查询列表
    async getList() {
      this.login1 = true;
      const formData = {
        queryData: this.queryData,
        page: this.pageInfo.page,
      };
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.video_inspection +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        formData
      );
      this.login1 = false;
      if (res.code != 0) return this.$message(res.msg);
      // this.list = res.data.list;
      this.pageInfo.total = res.data.total;
      // 处理一下list，copy 每一条list，吧from和to的imgList分别拆出来
      const tempList = [];
      res.data.list.forEach((item) => {
        const toList = {
          id: item.id,
          cid: item.cid,
          fromType: item.fromType,
          duration: item.duration,
          ctime: item.ctime,
          mtime: item.mtime,
          callTime: item.callTime,
          endReason: item.endReason,
          gender: "主播",

          countryCode: item.toCountryCode,
          user_lang: item.toLang,

          mute: item.toMute,
          rid: item.toRid,
          name: item.toName,
          channel: item.toChannel,
          appraiseLevel: item.toAppraiseLevel,
          ImgList: item.toImgList,
          videoUrl: item.toVideoUrl,
          videoRealUrl: item.toVideoRealUrl,
          operator: item.operator,
          userRobot: item.userRobot,
          evaluateType: item.evaluateType,
          evaHandleStatus: item.evaHandleStatus,
          evaluateReason: item.evaluateReason,
        };
        const fromList = {
          id: item.id,
          cid: item.cid,
          fromType: item.fromType,
          duration: item.duration,
          ctime: item.ctime,
          mtime: item.mtime,
          callTime: item.callTime,
          endReason: item.endReason,

          gender: "用户",

          countryCode: item.fromCountryCode,
          user_lang: item.fromLang,

          mute: item.fromMute,
          rid: item.fromRid,
          name: item.fromName,
          channel: item.fromChannel,
          appraiseLevel: item.fromAppraiseLevel,
          ImgList: item.fromImgList,
          videoUrl: item.fromVideoUrl,
          videoRealUrl: item.fromVideoRealUrl,
          operator: item.operator,
          userRobot: item.userRobot,
          evaluateType: item.evaluateType,
          evaHandleStatus: item.evaHandleStatus,
          evaluateReason: item.evaluateReason,
        };
        tempList.push(toList);
        tempList.push(fromList);
      });
      this.list = tempList;
    },
    playVideo(url) {
      this.vid = true;
      setTimeout(() => {
        let myPlayer = videojs("video"); //获取video的id值
        myPlayer.src(url);
        myPlayer.play();
      }, 1000);
    },
    look_() {
      this.vid = false;
      this.resetPlayer();
    },
    resetPlayer() {
      let myPlayer = videojs("video"); //获取video的id值
      myPlayer.pause();
      myPlayer.reset(""); // 清空视频源，重置播放器
      console.log("resetPlayer");
    },
    getMimeType(url) {
      if (url.endsWith(".mp4")) {
        return "video/mp4";
      } else if (url.endsWith(".m3u8")) {
        return "application/x-mpegURL";
      }
      return "video/mp4";
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // cid，fromType，duration，ctime，mtime，callTime，endReason，evaluateType，evaHandleStatus，evaluateReason合并为一行
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex === 11 ||
        columnIndex === 12 ||
        columnIndex === 13 ||
        columnIndex === 14 ||
        columnIndex === 15 ||
        columnIndex === 16 ||
        columnIndex === 17 ||
        columnIndex === 18
      ) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    format_(data) {
      let date = new Date(data * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-";
      let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    // 用户机器人视频更新
    async updateUserRobot(row, robotType) {
      console.log(row, robotType);
      try {
        // 根据robotType确定操作文本
        let actionText = '';
        switch (robotType) {
          case 0:
            actionText = '设为非机器人';
            break;
          case 1:
            actionText = '设为普通机器人';
            break;
          case 2:
            actionText = '设为私call机器人';
            break;
          default:
            actionText = '更新机器人状态';
        }
        
        // 弹出确认对话框
        const confirmResult = await this.$confirm(
          `确定要将用户 ${row.name} ${actionText}吗？`,
          '确认更新',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        
        if (confirmResult !== 'confirm') return;
        
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.video_inspection_update,
          {
            id: row.id,
            userRobot: robotType
          },
          {
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token
            }
          }
        );
        
        if (res.code === 0) {
          this.$message.success(`${actionText}成功`);
          // 只更新本地数据，不重新拉取
          row.userRobot = robotType;
        } else {
          this.$message.error(res.msg || '更新失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新用户机器人状态失败:', error);
          this.$message.error('更新失败，请重试');
        }
      }
    },
    // 打开评价处理对话框
    openEvaHandleDialog(row) {
      this.currentEvaHandleRow = row;
      this.evaHandleForm = {
        id: row.id,
        evaHandleStatus: row.evaHandleStatus !== undefined ? row.evaHandleStatus : 0,
      };
      this.evaHandleDialogVisible = true;
    },
    // 确认评价处理（第一次确认）
    async confirmEvaHandle() {
      if (this.evaHandleForm.evaHandleStatus === null || this.evaHandleForm.evaHandleStatus === undefined) {
        this.$message.warning('请选择处理状态');
        return;
      }
      
      // 关闭第一个对话框
      this.evaHandleDialogVisible = false;
      
      // 二次确认
      try {
        const statusText = this.evaHandleForm.evaHandleStatus === 1 ? '已处理' : '未处理';
        await this.$confirm(
          `确定要将评价处理状态设置为"${statusText}"吗？`,
          '二次确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        
        // 调用接口
        await this.submitEvaHandle();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('确认评价处理失败:', error);
        }
      }
    },
    // 提交评价处理
    async submitEvaHandle() {
      try {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.patrol_update_eva_status,
          {
            id: this.evaHandleForm.id,
            evaHandleStatus: this.evaHandleForm.evaHandleStatus
          },
          {
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token
            }
          }
        );
        
        if (res.code === 0) {
          this.$message.success('评价处理状态更新成功');
          // 更新本地数据
          if (this.currentEvaHandleRow) {
            this.currentEvaHandleRow.evaHandleStatus = this.evaHandleForm.evaHandleStatus;
          }
          // 刷新列表
          this.getList();
        } else {
          this.$message.error(res.msg || '更新失败');
        }
      } catch (error) {
        console.error('提交评价处理失败:', error);
        this.$message.error('更新失败，请重试');
      }
    },
    // 打开金币补偿对话框
    openCompensateDialog(row) {
      this.currentCompensateRow = row;
      this.compensateForm = {
        id: row.id,
        compensateGold: null,
      };
      this.compensateDialogVisible = true;
    },
    // 确认金币补偿（第一次确认）
    async confirmCompensate() {
      if (!this.compensateForm.compensateGold || this.compensateForm.compensateGold <= 0) {
        this.$message.warning('请输入有效的补偿金额');
        return;
      }
      
      // 关闭第一个对话框
      this.compensateDialogVisible = false;
      
      // 二次确认
      try {
        await this.$confirm(
          `确定要补偿 ${this.compensateForm.compensateGold} 金币吗？`,
          '二次确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        
        // 调用接口
        await this.submitCompensate();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('确认金币补偿失败:', error);
        }
      }
    },
    // 提交金币补偿
    async submitCompensate() {
      try {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.patrol_compensate,
          {
            id: this.compensateForm.id,
            compensateGold: this.compensateForm.compensateGold
          },
          {
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token
            }
          }
        );
        
        if (res.code === 0) {
          this.$message.success('金币补偿成功');
          // 刷新列表
          this.getList();
        } else {
          this.$message.error(res.msg || '补偿失败');
        }
      } catch (error) {
        console.error('提交金币补偿失败:', error);
        this.$message.error('补偿失败，请重试');
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
.imgList{
  display:flex;
  flex-wrap:nowarp;
  img{
    flex: 0 0 auto;
  }
}
.po {
  width: 480px;
  height: 640px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.pos {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: -50px;
  transform: scale(2);
}
.btns{
  display:flex;
  flex-direction: column;
  align-items: center;
  gap:10px;
  button{
    margin:0;
  }
}
</style>
